module.exports = __webpack_public_path__ + "assets/img/languageChip.1a2c59dc.png";